// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Tooltip from '../Tooltip';

import './Checkbox.less';

/**
 * `Checkbox` component.
 */
class Checkbox extends Component {
    handleChange = event => {
        const { disabled, onChange } = this.props;
        if (!disabled && onChange) {
            onChange(event.target.checked);
        }
    };

    render() {
        const {
            baseClassName,
            className,
            children,
            onChange,
            tooltip,
            checked,
            defaultChecked,
            disabled,
            inputProps,
            ...props
        } = this.props;

        let result = (
            <label
                className={classNames(
                    baseClassName,
                    className,
                )}
                {...props}
            >
                <input
                    className={`${baseClassName}__input`}
                    type="checkbox"
                    onChange={this.handleChange}
                    checked={checked}
                    defaultChecked={defaultChecked}
                    disabled={disabled}
                    {...inputProps}
                />
                <span className={`${baseClassName}__indicator`} />
                {children ? <span className={`${baseClassName}__text`}>{children}</span> : null}
            </label>
        );

        if (tooltip) {
            result = (
                <Tooltip title={tooltip}>
                    {result}
                </Tooltip>
            );
        }

        return result;
    }
}

Checkbox.propTypes = {
    /**
     * Determine whether the `Checkbox` is checked.
     */
    checked: PropTypes.bool,
    /**
     * @ignore
     */
    defaultChecked: PropTypes.bool,
    /**
     * A callback function, can be executed when the checked state is changing.
     */
    onChange: PropTypes.func,
    /**
     * Tooltip for component
     */
    tooltip: PropTypes.node,
    disabled: PropTypes.bool,
    /**
     * Label of the `Checkbox`
     */
    children: PropTypes.any,
    /**
     * Additional props for input element
     */
    inputProps: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Checkbox.defaultProps = {
    checked: undefined,
    defaultChecked: undefined,
    onChange: undefined,
    tooltip: undefined,
    disabled: false,
    children: undefined,
    inputProps: {},
    className: undefined,
    baseClassName: `${CLS_PREFIX}checkbox`,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./components/Checkbox/Checkbox.js